import { selectorFamily } from 'recoil';
import { allValid, fileUploadValidationSelector } from '@zurich/common/recoil';
import { documentTypeSelector } from '../../utils';
import { localPartyDocumentMetadataCountryOfIssueValidationSelector, localPartyDocumentMetadataDDocNumberValidationSelector, localPartyDocumentMetadataDDocSinceValidationSelector, localPartyDocumentMetadataDDocUntilValidationSelector, localPartyDocumentMetadataDiplomaticStatusValidationSelector, localPartyDocumentMetadataDocSubTypeSelector, localPartyDocumentMetadataDocSubTypeValidationSelector, localPartyDocumentMetadataDriversLicenseNumberValidationSelector, localPartyDocumentMetadataExpriryDateValidationSelector, localPartyDocumentMetadataIdentityDocumentNumberValidationSelector, localPartyDocumentMetadataIssueDateValidationSelector, localPartyDocumentMetadataIssuingAuthorityValidationSelector, localPartyDocumentModificatioReasonValidationSelector, partyAtom, } from '../index';
export const localPartyDocumentFormValidationSelector = selectorFamily({
    key: '@zurich/portal/local/validation/document/fileUpload',
    get: ({ action, partyModified }) => ({ get }) => {
        const { isDriversLicense, isIdentityDocument, isLegitimationCard } = documentTypeSelector(get(localPartyDocumentMetadataDocSubTypeSelector));
        const { dateOfBirth } = get(partyAtom);
        return allValid({
            ...(partyModified && {
                modificationReason: get(localPartyDocumentModificatioReasonValidationSelector),
            }),
            ...(action === 'create' && {
                fileUpload: get(fileUploadValidationSelector('party-upload-document')),
            }),
            docSubType: get(localPartyDocumentMetadataDocSubTypeValidationSelector),
            ...(isDriversLicense && {
                driversLicenseNumber: get(localPartyDocumentMetadataDriversLicenseNumberValidationSelector),
            }),
            ...(isIdentityDocument && {
                identityDocumentNumber: get(localPartyDocumentMetadataIdentityDocumentNumberValidationSelector),
            }),
            ...(isLegitimationCard && {
                dDocNumber: get(localPartyDocumentMetadataDDocNumberValidationSelector),
                dDocSince: get(localPartyDocumentMetadataDDocSinceValidationSelector(dateOfBirth)),
                dDocUntil: get(localPartyDocumentMetadataDDocUntilValidationSelector),
                diplomaticStatus: get(localPartyDocumentMetadataDiplomaticStatusValidationSelector),
            }),
            ...(!isLegitimationCard && {
                issuingAuthority: get(localPartyDocumentMetadataIssuingAuthorityValidationSelector),
                issueDate: get(localPartyDocumentMetadataIssueDateValidationSelector),
                countryOfIssue: get(localPartyDocumentMetadataCountryOfIssueValidationSelector),
            }),
            ...((isDriversLicense || isIdentityDocument) && {
                expiryDate: get(localPartyDocumentMetadataExpriryDateValidationSelector),
            }),
        });
    },
});
